





















































































































































































































































































































































































































import { Vue, Component, Prop, Ref } from "vue-property-decorator";
import { StaffSurveyFormResponse, StaffSurveySubmission } from "@/api";
import { VForm } from "@/common/vuetify_types";
import { StaffSurveyFormCollection } from "@/common/InspectionDataCollection";
import { dateFormat } from "@/common/date_format";
import _ from "lodash";
import { selfData } from "@/common/role_utils";
import {
  maxLenInt,
  noSpace,
  numberOnly,
  requiredSelectWithZero,
  requiredString,
  validateCharacter,
} from "@/tool/validation";
import ConfirmModule from "@/components/confirmationModule/ConfirmationModule.vue";
import moment from "moment";

@Component({
  components: {
    ConfirmModule,
  },
})
export default class StaffSurveyForm extends Vue {
  @Prop() readonly dispatchType!: string;
  @Prop() readonly title!: string;

  @Ref("initialForm") initialForm!: VForm;
  @Ref("form") form!: VForm;

  step = 0;
  self = selfData();
  submitting = false;
  confirmClose = false;
  dischargeDatePicker = false;
  admissionDatePicker = false;
  admissionDate = "";
  dischargeDate = "";
  firstNameInitial = "";
  lastNameInitial = "";
  textRules = [requiredString, noSpace];
  charRules = [validateCharacter];
  selectRules = [requiredSelectWithZero];
  numberRules = [numberOnly];
  phoneRules = [
    requiredString,
    numberOnly,
    noSpace,
    (v: string) => maxLenInt(v, 10),
  ];

  minDate = moment()
    .local()
    .format("YYYY-MM-DD");
  surveyData: StaffSurveyFormCollection[] = [];
  payload: StaffSurveySubmission = {
    id: 0,
    companyId: selfData().companyId,
    formId: 0,
    staffId: selfData().id,
    submittedDate: new Date().toISOString(),
    surveyData: [],
    createdAt: new Date().toISOString(),
  };
  commentError = "";
  feedbackError = "";
  meetError = "";
  ratingError = "";
  completedByOption = ["Family", "Friends", "Patient"];
  completedBy = "";

  async created() {
    await this.$store.dispatch("room/fetchCompanyRooms");
  }

  get questionLists() {
    let index = 0;
    this.surveyData = [];
    const activeForm =
      (this.$store.getters[
        "staffSurvey/activeForm"
      ] as StaffSurveyFormResponse) || null;
    if (activeForm) {
      this.payload.formId = activeForm?.id || 0;
      _.sortBy(activeForm.questions || [], ["order"], ["desc"]);
      _.forEach(activeForm.questions || [], question => {
        const data = {
          index: index,
          question: question,
          data: {
            id: 0,
            submissionId: 0,
            questionId: question.id,
            answerText: undefined,
            answerBool: undefined,
            answerOptionId: undefined,
            answerOptionIds: [],
            answerRating: undefined,
            skipQuestion: false,
            createdAt: new Date().toISOString(),
          },
        };
        this.surveyData.push(JSON.parse(JSON.stringify(data)));
        index++;
      });
      return this.surveyData;
    }

    return [];
  }

  formatDate(date: string) {
    this.payload.submittedDate = dateFormat(date);
  }

  nextInspection() {
    const valid = this.initialForm.validate();
    if (valid) {
      this.payload.companyId = this.self.companyId;
      this.payload.staffId = selfData().id;
      this.step++;
    }
  }

  clearError() {
    this.commentError = "";
    this.feedbackError = "";
    this.meetError = "";
    this.ratingError = "";
  }

  validate(item: StaffSurveyFormCollection): boolean {
    this.clearError();
    let valid = true;
    if (item.question.isRequired) {
      if (
        item.question.questionType == "rating" &&
        item.data.answerRating == undefined
      ) {
        this.feedbackError = "Give 1-5 rating.";
        valid = false;
      } else if (
        item.question.questionType == "single_choice" &&
        item.data.answerOptionId == undefined
      ) {
        this.feedbackError = "Please select at least one option.";
        valid = false;
      } else if (
        item.question.questionType == "multiple_choice" &&
        (item.data.answerOptionIds == undefined ||
          item.data.answerOptionIds.length == 0)
      ) {
        this.feedbackError = "Please select at least one option.";
        valid = false;
      } else if (
        item.question.questionType == "text" &&
        (item.data.answerText === undefined || item.data.answerText === "")
      ) {
        this.commentError = "Provide an answer.";
        valid = false;
      }
    } else {
      if (
        item.question.questionType == "rating" &&
        item.data.answerRating == undefined &&
        !item.data.skipQuestion
      ) {
        this.meetError = "Give 1-5 rating or select checkbox for skip.";
        valid = false;
      } else if (
        item.question.questionType == "single_choice" &&
        item.data.answerOptionId == undefined &&
        !item.data.skipQuestion
      ) {
        this.meetError =
          "Please select at least one option or select checkbox for skip.";
        valid = false;
      } else if (
        item.question.questionType == "text" &&
        item.data.answerText === "" &&
        !item.data.skipQuestion
      ) {
        this.meetError = "Provide an answer or select checkbox for skip.";
        valid = false;
      }
    }

    return valid;
  }

  next(item: StaffSurveyFormCollection) {
    const valid = this.validate(item);
    if (valid) this.step++;
  }

  async submit(item: StaffSurveyFormCollection) {
    const valid = this.validate(item);
    if (valid) {
      this.submitting = !this.submitting;
      this.payload.surveyData = [];
      // eslint-disable-next-line
      _.forEach(this.surveyData, item => {
        if (item?.data.skipQuestion) item.data.answerRating = 0;
        this.payload.surveyData.push({
          ...item.data,
        });
      });
      await this.$store.dispatch("staffSurvey/createStaffSurveySubmission", {
        requestBody: this.payload,
        slug: this.dispatchType,
      });
      this.submitting = !this.submitting;
      this.complete();
      // this.step++;
    }
  }

  close() {
    this.$emit("close");
  }

  complete() {
    this.$emit("complete");
  }

  recognize() {
    this.$emit("recognize");
  }
}
